// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__30VCq","content":"ManualTimeModal_content__ZgxO6"};